// metadata/dynamic.ts
import { getTypeString } from "../baseqlTypes.js";
import { registerField } from "../decorators/field.js";
import { baseqlMetaData } from "./metaDataStore.js";
import { registerEntity } from "./register.js";
var addDynamicEntity = (DynamicClass, fields, options) => {
  for (const [name, { type, options: options2 }] of Object.entries(fields)) {
    registerField(DynamicClass.prototype, type, name, options2, true);
  }
  registerEntity(DynamicClass, options, true);
};
var addDynamicField = (node, field) => {
  const targetNode = baseqlMetaData.entities.resolveNode(node);
  if (targetNode.fields[field.name])
    throw new Error(
      `trying to add field ${field.name} to entity ${getTypeString(targetNode.type)}, but it already exists`
    );
  field.dynamic = true;
  targetNode.fields[field.name] = field;
};
var resetDynamicMetadata = () => {
  baseqlMetaData.entities.forEach((node) => {
    node.children = node.children.filter((child) => {
      return !child.dynamic;
    });
    for (const fieldName of Object.keys(node.fields)) {
      if (node.fields[fieldName]?.dynamic) {
        delete node.fields[fieldName];
      }
    }
  });
  Object.entries(baseqlMetaData.enums).forEach(([enumKey, enumNode]) => {
    if (enumNode.dynamic)
      delete baseqlMetaData.enums[enumKey];
  });
};
export {
  addDynamicEntity,
  addDynamicField,
  resetDynamicMetadata
};
